import path from 'node:path';
import crypto from 'node:crypto';
import { INDEX_HASH_LEN } from './constants.js';

/** Stable short hash for a file-index parent path (matches legacy JSON index hash length). */
export function getCwdHashForFileIndex(resolvedCwd: string): string {
  return crypto.createHash('sha256').update(path.resolve(resolvedCwd)).digest('hex').slice(0, INDEX_HASH_LEN);
}
